export default __webpack_public_path__ + "static/media/ellipse.d695b2ef.svg";